<script setup lang="ts">
import { inject } from 'vue'

import { useRoute } from 'vue-router'

const router = useRoute()

const lang: string = router.params.lang as string
const BRAND = inject('BRAND')
</script>
<template>
  <div class="-mb-2 flex justify-center pt-1.5">
    <a
      :href="`https://www.${BRAND}.com/${lang}/${$t('imprinturl')}`"
      target="_blank"
      class="text-zinc-500/70 text-sm hover:underline"
    >
      {{ $t('imprint') }}
    </a>
  </div>
</template>

<style scoped></style>
